export default class StatsObserver {
    constructor() {
        this.statsSection = document.querySelector('.stats');
        this.statSections = document.querySelectorAll('.stat');
        this.activeClass = 'active';

        if (!this.statsSection || this.statSections.length === 0) {
            console.warn('The required elements (.stats or .stat) were not found in the document.');
            return;
        }

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            threshold: 0.5,
        });

        this.startObserving();
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add 'active' class to the section currently in view instead of all sections with the class 'stat'
                this.statSections.forEach((stat) => {
                    stat.classList.add(this.activeClass);
                })
                //entry.target.classList.add(this.activeClass);
                // Unobserve the section once it has animated
                this.observer.unobserve(entry.target);
            }
        });
    }

    startObserving() {
        if (this.statsSection) {
            // Start observing each section
            this.statSections.forEach(section => {
                this.observer.observe(section);
            });
        }
    }
}